
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events",
      function () {
        return require("private-next-pages/events/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events"])
      });
    }
  